import { API } from "shared/constants/AppEnums"

export const getDocuments = async (page, filter, publicState, general, byTitle, unker, satker, documentType) => {
    try {
        let published = filter === 'publish' || filter === 'revision' || filter === 'review' ? true : false
        let tipe = filter === 'revision' || filter === 'review' ? `&tipe=${filter}` : ''

        const response = await fetch(API.DOCUMENTS.replace('$page', page).replace('$published', published).replace('$public', publicState).replace('$general', general).replace('$unker', unker).replace('$satker', satker).replace('$byTitle', byTitle) + tipe + `&tipe_dokumen=${documentType}`, {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getDocSharedWithMe = async (page, type, documentType, general) => {
    try {
        let tipe = type === 'tinjauan' ? 'review' : 'done'
        const response = await fetch(API.SHARE_DOCUMENTS.replace('$page', page) + `&tipe=${tipe}&tipe_dokumen=${documentType}&general=${general}`, {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token')
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getFilterDocuments = async (type, value, published, publicState, byTitle, unker, satker, filter, documentType) => {
    try {
        let url = ''
        if (type === 'dokumen') {
            let tipe = filter === 'revision' || filter === 'review' ? `&tipe=${filter}` : ''

            url = API.FILTER_DOCUMENT.replace('$value', value).replace('$published', published).replace('$public', publicState).replace('$unker', unker).replace('$satker', satker).replace('$byTitle', byTitle) + tipe + `&tipe_dokumen=${documentType}`
        } else {
            url = API.FILTER_SHARE_WITH_ME.replace('$value', value) + `&tipe=${type === 'tinjauan' ? 'review' : 'done'}&tipe_dokumen=${documentType}`
        }
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token')
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const addDocumentAttachment = async (file) => {
    try {
        var formData = new FormData()
        formData.append("files", file)

        const response = await fetch(API.ADD_DOCUMENT_ATTACHMENT, {
            method: 'POST',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            },
            body: formData
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const deleteDocumentAttachment = async (id) => {
    try {
        const response = await fetch(API.DELETE_DOCUMENT_ATTACHMENT.replace('$id', id), {
            method: 'DELETE',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const addDocument = async (data, documentType) => {
    try {
        const response = await fetch(documentType === 'dokumen_drive' ? API.ADD_DOCUMENT : API.ADD_DOCUMENT_BPK, {
            method: 'POST',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const editDocument = async (id, data) => {
    try {
        const response = await fetch(API.EDIT_DOCUMENT.replace('$id', id), {
            method: 'PUT',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getDetailDocument = async (id) => {
    try {
        const response = await fetch(API.DETAIL_DOCUMENT.replace('$id', id), {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token')
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const deleteDocument = async (id) => {
    try {
        const response = await fetch(API.DELETE_DOCUMENT.replace('$id', id), {
            method: 'DELETE',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
                'Content-Type': 'application/json'
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const addComment = async (payload) => {
    try {
        const response = await fetch(API.ADD_COMMENT, {
            method: 'POST',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        })

        return response.json()
    } catch (error) {
        return error
    }
}

export const rateDocument = async (id, data) => {
    try {
        const response = await fetch(API.RATE_DOCUMENT.replace('$id', id), {
            method: 'PUT',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
        return response.json()
    } catch (error) {
        return error
    }
}


export const updateDocumentAttachment = async (id, file) => {
    try {
        var formData = new FormData()
        formData.append("files", file)
        console.log(file)
        const response = await fetch(API.UPDATE_DOCUMENT_ATTACHMENT.replace('$id', id), {
            method: 'PUT',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            },
            body: formData
        })
        return response.json()
    } catch (error) {
        return error
    }
}


export const attachmentView = async (id) => {
    try {
        const response = await fetch(API.ATTACHMENT_VIEW.replace('$id', id), {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token')
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getUnkerPreparing = async () => {
    try {
        const response = await fetch(API.GETUNKER, {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getSatkerByUnkerPreparing = async (id) => {
    try {
        const response = await fetch(API.GETSATKERBYUNKER.replace('$id', id), {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}


export const updateStateDocument = async (id, data) => {
    try {
        const response = await fetch(API.UPDATE_STATE_DOCUMENT.replace('$id', id), {
            method: 'PUT',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getDocumentCounter = async (tipeDokumen) => {
    try {
        const response = await fetch(API.GET_DOCUMENT_COUNTER.replace('$tipe', tipeDokumen), {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token')
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}